export const RECIPIENT_DATA: readonly string[] = [
	'Action St. Louis',
	'Austin Justice Coalition',
	'Beauty for Freedom',
	'Black Equity Collective',
	'Black LGBTQIA+ Migrant Project (BLMP)',
	'Black Lives Matter Global Network',
	'Black Mental Health Alliance',
	'Black Organizing for Leadership & Dignity (BOLD)',
	'Black Swan Academy',
	'Black Visions Collective',
	'Black Youth Project',
	'BlackOUT Collective',
	'Bread & Roses Community Fund',
	'Chicago Torture Justice Center',
	'Children of Promise',
	'Chinook Fund',
	'Crossroads Fund',
	'Cypress Fund',
	'Dream Defenders',
	'East Oakland Collective',
	'Essie Justice Group',
	'Freedom Agenda',
	'Freedom, Inc.',
	'Grassroots Alliance for Police Accountability',
	'Haymarket People’s Fund',
	'Hidden Genius Project',
	'Headwaters Foundation for Justice',
	'Highlander Research and Education Center',
	'Law 4 Black Lives',
	'Let Us Breathe Fund (NY)',
	'Live Free USA, a project of Faith in Action Network',
	'Marsha P. Johnson Institute',
	'Mass Liberation Arizona',
	'Movement for Black Lives',
	'New Jersey Institute of Social Justice',
	'North Carolina Black Leadership and Organizing Collective (NC BLOC)',
	'People’s Advocacy Institute',
	'Perinatal Health Equity Foundation',
	'Social Justice Fund NW',
	'Solutions Not Punishment Collaborative (SNaPCo)',
	'Southerners on New Ground',
	'Third Wave Fund',
	'UndocuBlack Network',
	'W.E.B. Du Bois Scholars Institute',
	'Women on the Rise',
];
